import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppButtonModule } from '../../dave-utils-module/app-button-module/app-button.module';
import { ChartOfAccountEntity } from '../../dave-data-module/entities/chart-of-Account.entity';
import { PersonTypeEntity } from '../../dave-data-module/entities/personType.entity';


@Component({
    selector: 'app-edit-persontype',
    standalone: true,
    imports: [CommonModule, AppButtonModule, FontAwesomeModule, MatTooltipModule],
    templateUrl: './edit-persontype.component.html',
    styleUrls: ['./edit-persontype.component.scss'],
})
export class EditPersontypeComponent  {
    @Input()  public PersonType: PersonTypeEntity;
    @Output() editEvent = new EventEmitter<PersonTypeEntity>();

    constructor() {}

    onEditClick( event: PersonTypeEntity ) {
        this.editEvent.emit(event);
    }
    get isButtonDisabled(): boolean {
        return this.PersonType?.PartnerId === null;
    }
}
